import { jsx as l, jsxs as I } from "react/jsx-runtime";
import g from "clsx";
import { createContext as _e, useMemo as R, useState as C, useEffect as v, useContext as S, forwardRef as Le, useRef as D, useCallback as Ae } from "react";
import { s as W, af as ee, bo as Pe, T as De, i as U, ai as te, Q as F, F as Me, w as O, a4 as ne, aL as Ge, f as He, C as se, a0 as oe, a1 as P, n as Be, ao as Re, aJ as ze, r as $e, t as We, aM as Ue, G as Fe } from "./helpers-458d7e27.js";
import { H as ie, c as ae, d as re, e as ce, b as Ve, f as qe, a as Ke, g as je, S as le, n as ue, h as Je, u as Qe, i as Xe, j as Ye, s as Ze, k as et } from "./useSubNavHeight-9afc367c.js";
import { N as _ } from "./NavButton-bf29eafc.js";
import "@emotion/react";
import "@paypalcorp/pp-react-theme";
import "@paypalcorp/pp-react-icons";
import "react-dom";
const N = _e({
  classNameGen: {},
  analyticsCompName: "",
  getDataPaClickString: () => ""
}), tt = ({
  classNameGen: t,
  analyticsCompName: n,
  generateDataPaClickFunction: e,
  children: i
}) => {
  const { environment: { pageSegment: o = "" } = {} } = W(), s = R(
    () => e(o, n),
    [e, o, n]
  ), r = R(
    () => ({
      classNameGen: t,
      analyticsCompName: n,
      getDataPaClickString: s
    }),
    [t, n, s]
  );
  return /* @__PURE__ */ l(N.Provider, { value: r, children: i });
}, H = { cta: "CTA", hero: "Hero" }, nt = () => {
  const [t, n] = C("skip-check"), { height: e } = ee(0);
  return v(() => {
    let i = document.querySelectorAll(
      `${ie}, ${ae}`
    ), o = H.cta;
    if (i.length || (i = document.querySelectorAll(
      `${re}, ${ce}`
    ), o = H.hero), !i.length || e <= 0)
      return n("skip-check");
    const s = ([a]) => o === H.cta ? n(a.isIntersecting ? "active" : "inactive") : n(a.isIntersecting ? "inactive" : "active"), r = -1 * (e - 1), c = new IntersectionObserver(s, {
      threshold: 0.1,
      rootMargin: o === "CTA" ? `50000px 0px ${r}px 0px` : ""
    });
    return i.forEach(
      (a) => c.observe(a)
    ), () => {
      i.forEach(
        (a) => c.unobserve(a)
      );
    };
  }, [e]), t;
}, Q = (t) => `${t}px`, st = ({ ...t }) => /* @__PURE__ */ l(U, { as: "div", ...t }), de = {
  as: st,
  motionOptions: Pe
}, me = (t) => ({
  options: {
    rowsMinHeight: Q(
      t ? Ve : qe
    )
  },
  mdOptions: {
    rowsMinHeight: Q(
      t ? Ke : je
    )
  }
}), pe = (t, n, e = "") => g(
  De.getThemeClassName(n),
  t.getComponentClassName(),
  e
), ot = ({
  theme: t,
  shouldShrinkNav: n,
  updateNavRunningStatus: e,
  children: i,
  className: o
}) => {
  const s = nt(), { classNameGen: r, analyticsCompName: c } = S(N);
  v(() => {
    if (s === "active") {
      e("pinned");
      return;
    }
    if (s === "inactive") {
      e("running");
      return;
    }
    e("unavailable");
  }, [s, e]);
  const a = g(
    pe(r, t, o),
    r.getElementClassName("position-fixed"),
    {
      [r.getElementClassName("hidden")]: s === "inactive",
      [r.getElementClassName("visible")]: s === "active"
    }
  );
  return /* @__PURE__ */ l(
    te,
    {
      id: c,
      className: a,
      ...de,
      ...me(n),
      children: i
    }
  );
}, it = () => {
  const [t, n] = C("skip-check"), { height: e } = ee(0), [i] = F(["Below MD"]);
  return v(() => {
    const o = document.querySelector(le);
    if (!o || e <= 0)
      return n("skip-check");
    const s = ([a]) => {
      n(a.isIntersecting ? "pinned" : "unpinned");
    }, r = -1 * (e - 1), c = new IntersectionObserver(s, {
      rootMargin: `50000px 0px ${r}px 0px`
    });
    return c.observe(o), () => {
      c == null || c.unobserve(o);
    };
  }, [e, i]), t;
}, at = ({
  theme: t,
  shouldShrinkNav: n,
  updateNavRunningStatus: e,
  children: i,
  className: o
}) => {
  const s = it(), { classNameGen: r, analyticsCompName: c } = S(N);
  v(() => {
    if (s === "pinned") {
      e("pinned");
      return;
    }
    if (s === "unpinned") {
      e("running");
      return;
    }
    e("unavailable");
  }, [s, e]);
  const a = g(
    pe(r, t, o),
    r.getElementClassName("position-sticky"),
    {
      [r.getElementClassName("unpinned")]: s === "unpinned",
      [r.getElementClassName("pinned")]: s === "pinned"
    }
  );
  return /* @__PURE__ */ l(
    te,
    {
      id: c,
      className: a,
      ...de,
      ...me(n),
      children: i
    }
  );
};
const rt = ({
  ariaLabel: t,
  children: n
}) => {
  const { classNameGen: e } = S(N);
  return /* @__PURE__ */ l(
    "nav",
    {
      "aria-label": t,
      className: e.getElementClassName("container"),
      children: n
    }
  );
}, ct = (t) => {
  switch (t) {
    case "ppe":
      return "Body Large Bold";
    default:
      return "Title";
  }
};
const B = "title-no-scrollable", z = ({
  title: t,
  as: n = t.type || "Title",
  isPopupTitle: e,
  isPopupOpen: i,
  scrollableTitle: o = !0,
  enableRichText: s = !1,
  onClick: r,
  displayTitle: c
}) => {
  const { classNameGen: a, getDataPaClickString: p } = S(N), { foundationTheme: d } = S(Me), {
    environment: { host: u = "" } = {},
    requestor: { locality: { country: m = "" } = {} } = {}
  } = W(), h = p(
    "Title",
    t.text,
    O.Button
  ), E = p(
    "Title",
    t.text,
    O.Link
  );
  if (n === "Title") {
    const w = g(
      a.getElementClassName("title-text")
    ), f = () => {
      const G = ct(d);
      return /* @__PURE__ */ l(Ge, { as: "span", size: G, className: w, children: t.text });
    }, L = () => /* @__PURE__ */ l(
      He,
      {
        as: "span",
        content: t.text,
        className: w
      }
    );
    return /* @__PURE__ */ l(
      "p",
      {
        className: g(a.getElementClassName("title"), {
          [a.getElementClassName("title-popup")]: e,
          [a.getElementClassName(B)]: !o,
          [a.getElementClassName("no-title")]: c === "Collapsed only"
        }),
        children: s ? L() : f()
      }
    );
  }
  if (n === "Button") {
    const w = g(
      a.getElementClassName("title"),
      a.getElementClassName("title-button")
    ), f = g(
      a.getElementClassName("title-container"),
      {
        [a.getElementClassName(B)]: !o
      }
    );
    return /* @__PURE__ */ l("div", { className: f, children: /* @__PURE__ */ l(
      _,
      {
        buttonType: "collapsible",
        panelType: "nav-popup",
        buttonText: t.text,
        onClick: r,
        "data-pa-click": h,
        "aria-controls": "sub-nav-popup",
        "aria-expanded": i,
        disabled: i,
        className: w
      }
    ) });
  }
  const { url: b, target: T } = t, k = g(
    a.getElementClassName("title"),
    a.getElementClassName("title-link"),
    {
      [a.getElementClassName("title-popup")]: e,
      [a.getElementClassName(B)]: !o
    }
  );
  return /* @__PURE__ */ l(
    _,
    {
      buttonType: "link",
      linkType: "title-link",
      buttonText: t.text,
      "data-pa-click": E,
      href: ne(b, u, m),
      target: T,
      className: k
    }
  );
}, ge = (t, n, e = !0) => {
  v(() => {
    const i = (o) => {
      var r;
      t.current && !((r = t.current) != null && r.contains(o.target)) && n && n();
    };
    return e ? window.addEventListener("click", i, !0) : window.removeEventListener("click", i, !0), () => window.removeEventListener("click", i, !0);
  }, [t, n, e]);
}, lt = ({
  menuId: t,
  isDropdownOpen: n,
  text: e,
  onClick: i,
  renderingStyle: o = "dropdown",
  containsCurrentPageLink: s
}) => {
  const { getDataPaClickString: r } = S(N), c = r(
    "Items",
    e,
    O.Button
  );
  return /* @__PURE__ */ l(
    _,
    {
      buttonType: "collapsible",
      panelType: o,
      "data-pa-click": c,
      onClick: i,
      buttonText: e,
      "aria-controls": t,
      "aria-expanded": n,
      containsCurrentPageLink: s
    }
  );
};
const ut = "Divider", X = new se(ut), $ = ({
  show: t = !0,
  orientation: n = "horizontal",
  className: e = ""
}) => {
  if (!t)
    return null;
  const i = g(
    X.getComponentClassName(),
    X.getPropsValueClassName("orientation", n),
    e
  );
  return /* @__PURE__ */ l("hr", { className: i });
}, M = Le(
  ({ orientation: t = "horizontal", isVisible: n = !0, className: e = "", children: i }, o) => {
    const { classNameGen: s } = S(N), r = g(
      s.getElementClassName("items-list"),
      {
        "sub-nav-item-hidden": !n,
        [s.getElementClassName("items-list-orientation-vertical")]: t === "vertical"
      },
      e
    );
    return /* @__PURE__ */ l("ul", { ref: o, className: r, "aria-hidden": !n, children: i });
  }
);
M.displayName = "ItemsList";
const ve = ({
  text: t,
  url: n,
  target: e,
  itemOrientation: i = "horizontal",
  isActive: o,
  onClick: s
}) => {
  const { classNameGen: r, getDataPaClickString: c } = S(N), a = c(
    "Items",
    t,
    O.Link
  ), {
    environment: { host: p = "" } = {},
    requestor: { locality: { country: d = "" } = {} } = {}
  } = W(), u = n ? ne(n, p, d) : void 0;
  return /* @__PURE__ */ l("li", { className: r.getElementClassName("list-item"), children: /* @__PURE__ */ l(
    _,
    {
      buttonType: "link",
      linkType: i === "horizontal" ? "nav-link" : "menu-link",
      buttonText: t,
      "data-pa-click": a,
      href: u,
      target: e,
      onClick: s,
      isActive: o
    }
  ) });
};
const dt = ({
  show: t,
  id: n,
  menuTitle: e,
  menuLinkCollection: i,
  renderingStyle: o
}) => {
  const { classNameGen: s } = S(N), r = g(
    s.getElementClassName("item-dropdown-menu"),
    {
      [s.getElementClassName("item-dropdown-menu-show")]: t,
      [s.getElementClassName("item-dropdown-menu-accordion-panel")]: o === "accordion"
    }
  ), c = {
    initial: {
      height: 0,
      opacity: 0,
      display: "none"
    },
    animate: {
      height: "auto",
      opacity: [0, 1, 1],
      display: "block"
    }
  }, a = {
    duration: P.constants.Functional.multiplier.appear * 2,
    ease: P.constants.Functional.ease
  }, p = o === "accordion" ? oe.div : U;
  return /* @__PURE__ */ I(p, { id: n, className: r, ...o === "accordion" ? {
    initial: "initial",
    variants: c,
    transition: a,
    animate: t ? "animate" : "initial"
  } : {
    motionOptions: ue,
    animate: t ? "animate" : "initial"
  }, children: [
    e && /* @__PURE__ */ l(z, { title: e }),
    /* @__PURE__ */ l(
      $,
      {
        className: s.getElementClassName(
          "item-dropdown-menu-divider"
        )
      }
    ),
    /* @__PURE__ */ l(M, { orientation: "vertical", isVisible: t, children: i.map((h, E) => /* @__PURE__ */ l(
      ve,
      {
        itemOrientation: "vertical",
        ...h
      },
      `menu-link-${E + 1}`
    )) })
  ] });
}, mt = ({
  text: t,
  menuTitle: n,
  menuLinkCollection: e,
  itemOrientation: i = "horizontal",
  containsCurrentPageLink: o = !1
}) => {
  const [s, r] = C(!1), { classNameGen: c } = S(N), a = i === "horizontal" ? "dropdown" : "accordion", p = a === "dropdown", d = () => r(!s), u = () => r(!1), m = D(null);
  ge(m, u, s);
  const h = () => {
    const f = n && n.type === "Link";
    return a === "dropdown" ? e : f ? [n, ...e] : e;
  }, E = () => n && n.type === "Title" ? n.text : t, T = (() => a === "dropdown" ? t : E())(), k = `${Be(T)}-${a}-menu`, w = g(
    c.getElementClassName("list-item"),
    {
      [c.getElementClassName("list-item-dropdown")]: a === "dropdown",
      [c.getElementClassName("list-item-accordion")]: a === "accordion",
      [c.getElementClassName("list-item-accordion-open")]: s && a === "accordion"
    }
  );
  return /* @__PURE__ */ I("li", { className: w, ref: m, children: [
    /* @__PURE__ */ l(
      lt,
      {
        menuId: k,
        text: T,
        isDropdownOpen: s,
        onClick: d,
        renderingStyle: a,
        containsCurrentPageLink: o
      }
    ),
    /* @__PURE__ */ l(
      dt,
      {
        show: s,
        id: k,
        menuTitle: p ? n : void 0,
        menuLinkCollection: h(),
        renderingStyle: a
      }
    )
  ] });
}, pt = (t, n = !0) => {
  const [e, i] = C(n);
  return Re(t, ([s]) => {
    typeof window < "u" && window.requestAnimationFrame(
      () => i(s.target.scrollWidth > s.target.clientWidth)
    );
  }), e;
}, gt = (t) => t.reduce((e, i) => {
  if (i.type === "Link")
    return e;
  const { menuLinkCollection: o, menuTitle: s } = i, c = ((s == null ? void 0 : s.type) === "Link" ? [s, ...o] : o).some(
    (a) => ze(a.url)
  );
  return {
    ...e,
    [i.text]: c
  };
}, {});
const Y = ({
  itemCollection: t,
  orientation: n = "horizontal",
  isVisible: e = !0,
  closePopupOnItemClick: i = !1,
  closeSubNavPopup: o,
  activeId: s,
  onOverflow: r
}) => {
  const c = D(null), a = pt(c), p = !t || t.length === 0;
  if (v(() => {
    r && r(p ? !1 : a);
  }, [
    r,
    n,
    a,
    p
  ]), p)
    return null;
  const d = gt(t);
  return /* @__PURE__ */ l(M, { ref: c, isVisible: e, orientation: n, children: t == null ? void 0 : t.map((u, m) => {
    const h = `sub-nav-item-${m + 1}`;
    return u.type === "Link" ? /* @__PURE__ */ l(
      ve,
      {
        ...u,
        onClick: (E) => {
          i && o && o(), u.onClick && u.onClick(E);
        },
        itemOrientation: n,
        isActive: u.url === `#${s}`
      },
      h
    ) : /* @__PURE__ */ l(
      mt,
      {
        ...u,
        itemOrientation: n,
        containsCurrentPageLink: d[u.text]
      },
      h
    );
  }) });
};
const Z = ({
  ctaCollection: t,
  orientation: n = "horizontal",
  isVisible: e = !0,
  closePopupOnItemClick: i = !1,
  closeSubNavPopup: o,
  displayCtaGroup: s = "Default"
}) => {
  const [r] = F(["Below LG"]), { classNameGen: c, analyticsCompName: a } = S(N), p = g(c.getElementClassName("cta-list"), {
    [c.getElementClassName("cta-list-orientation-vertical")]: n === "vertical",
    [c.getElementClassName("cta-list-always-on-navbar")]: s === "Always"
  });
  return !e && n === "vertical" || !t || t.length === 0 ? null : /* @__PURE__ */ l(
    M,
    {
      orientation: n,
      isVisible: e,
      className: p,
      children: t == null ? void 0 : t.map((d) => /* @__PURE__ */ l(
        "li",
        {
          className: c.getElementClassName("cta-list-item"),
          children: /* @__PURE__ */ l(
            $e,
            {
              analyticsCompName: a,
              ...d,
              onClick: () => {
                i && o && o();
              },
              size: r ? "Small" : "Large",
              className: c.getElementClassName("cta-item")
            }
          )
        },
        d.text
      ))
    }
  );
};
const vt = ({
  show: t,
  closeBtnLabel: n,
  onCloseButtonClick: e,
  children: i
}) => {
  const { classNameGen: o, getDataPaClickString: s } = S(N), r = D(null);
  ge(r, e, t);
  const c = s(
    "Popup",
    "close button",
    O.Button
  ), a = g(o.getElementClassName("popup"), {
    [o.getElementClassName("popup-show")]: t
  });
  return /* @__PURE__ */ I(
    U,
    {
      rootRef: r,
      id: "sub-nav-popup",
      className: a,
      motionOptions: ue,
      animate: t ? "animate" : "initial",
      children: [
        i,
        /* @__PURE__ */ l(
          _,
          {
            buttonType: "icon-button",
            iconType: "close",
            onClick: e,
            "data-pa-click": c,
            "aria-label": n,
            className: o.getElementClassName("popup-close-btn")
          }
        )
      ]
    }
  );
}, St = () => {
  const [t, n] = C("skip-check");
  return v(() => {
    const e = document.querySelectorAll(
      `${re}, ${ce}`
    );
    if (!e.length)
      return n("skip-check");
    const i = ([s]) => n(s.isIntersecting ? "visible" : "invisible"), o = new IntersectionObserver(i, {
      threshold: 0.1
    });
    return e.forEach(
      (s) => o.observe(s)
    ), () => {
      e.forEach(
        (s) => o.unobserve(s)
      );
    };
  }, []), t;
}, ht = () => {
  const [t, n] = C("skip-check");
  return v(() => {
    const e = document.querySelectorAll(
      `${ie}, ${ae}`
    );
    if (!e.length)
      return n("skip-check");
    const i = ([s]) => n(s.isIntersecting ? "visible" : "invisible"), o = new IntersectionObserver(i, {
      threshold: 0.1
    });
    return e.forEach(
      (s) => o.observe(s)
    ), () => {
      e.forEach(
        (s) => o.unobserve(s)
      );
    };
  }, []), t;
}, Nt = (t) => {
  const n = "slideIn";
  return t ? [n, "fadeOut"] : [n, "fadeIn"];
}, Ct = (t) => t ? "slideOut" : "fadeOut", bt = (t, n, e, i) => t === "invisible" || n === "invisible" ? Nt(e) : Ct(i), ft = {
  slideOut: {
    opacity: 0,
    width: 0,
    transitionEnd: {
      display: "none",
      visibility: "hidden"
    }
  },
  slideIn: {
    width: "auto",
    opacity: 1,
    display: "flex",
    visibility: "visible"
  },
  fadeOut: {
    opacity: 0,
    width: "auto",
    display: "flex",
    transitionEnd: {
      visibility: "hidden"
    }
  },
  fadeIn: {
    opacity: 1,
    width: "auto",
    display: "flex",
    visibility: "visible"
  }
};
const Et = ({ isAnimated: t, isPopupOpen: n, isStickyGrid: e, children: i }) => {
  const o = ht(), s = St(), r = We(), { classNameGen: c } = S(N), [a, p] = C(!1);
  if (v(() => {
    document.body.classList.toggle("hide-horizontal-scrollbar", a);
  }, [a]), !t)
    return i;
  const d = bt(
    o,
    s,
    n,
    e
  ), u = g(c.getElementClassName("cta-motion-wrapper")), m = () => p(!0), h = () => p(!1);
  return /* @__PURE__ */ l(
    oe.div,
    {
      className: u,
      variants: ft,
      initial: !1,
      animate: d,
      transition: {
        duration: r ? 0 : P.constants.Functional.multiplier.fixedMove * 1,
        ease: r ? 0 : P.constants.Functional.ease
      },
      onAnimationStart: m,
      onAnimationComplete: h,
      children: i
    }
  );
}, kt = () => {
  const [t, n] = C("not-in-use"), [e, i] = C(!1);
  v(() => {
    n(e ? "close" : "not-in-use");
  }, [e]), v(() => {
    e && t !== "open" && n("close");
  }, [e, t]);
  const o = () => n("open"), s = () => n("close"), r = Ae(
    (c) => i(c),
    []
  );
  return {
    subNavPopupStatus: t,
    openSubNavPopup: o,
    closeSubNavPopup: s,
    setNavItemsOverflowState: r
  };
}, wt = new Array(10).fill(null).map((t, n) => n * 0.1);
function Tt(t = []) {
  var p;
  const n = D(), [e, i] = C(/* @__PURE__ */ new Set()), o = R(() => t.length ? t.reduce((d, u) => (u.type === "Link" && u.url.startsWith("#") && d.push(u.url.substring(1)), d), []) : [], [t]), [s, r] = C(o[0]);
  v(() => (o.length && (n.current = new IntersectionObserver(
    (u) => {
      u.forEach((m) => {
        m != null && m.isIntersecting ? i(new Set(e.add(m.target.id))) : (e.delete(m.target.id), i(new Set(e)));
      });
    },
    {
      rootMargin: "0% 0% -95% 0%",
      threshold: wt
    }
  ), document.querySelectorAll("[id]").forEach((u) => {
    var m;
    o.includes(u.id) && ((m = n.current) == null || m.observe(u));
  })), () => {
    var d;
    return (d = n.current) == null ? void 0 : d.disconnect();
  }), []);
  const c = Array.from(e).sort((d, u) => o.indexOf(d) - o.indexOf(u)).pop(), a = c || s ? {
    type: "Title",
    text: ((p = Je(t, c ?? s)) == null ? void 0 : p.text) ?? ""
  } : void 0;
  return v(() => {
    o.length ? !c && !s || c === o[0] ? r(o[0]) : c === o[o.length - 1] && r(o[o.length - 1]) : r("");
  }, [c, o, s]), {
    activeSectionId: c,
    activeSectionTitle: a,
    stickyEdgeId: s
  };
}
const yt = ({ isSticky: t = !1, height: n = 0 }) => {
  const { registerStickyEl: e, updateStickyElStatus: i } = S(
    Ue
  );
  v(() => {
    e({
      type: "sub-nav",
      cssSelector: le,
      height: n,
      isSticky: !1
    });
  }, [n, e]), v(() => {
    i({ type: "sub-nav", isSticky: t });
  }, [t, i]);
};
const V = "SubNav", y = new se(V), x = "not-in-use", It = ({
  controlLabels: t = {},
  title: n = {},
  displayNav: e = "Always",
  itemCollection: i = [],
  ctaCollection: o = [],
  sectionalCtaCollection: s = {},
  theme: r = "white",
  analyticsCompName: c = V,
  className: a = "",
  subNavConfig: p = {
    displayTitle: "Always",
    borderBottom: "Show",
    displayCtaGroup: "Default"
  }
}) => {
  const { displayTitle: d, borderBottom: u, displayCtaGroup: m } = p, [h, E] = C("unavailable"), {
    subNavPopupStatus: b,
    openSubNavPopup: T,
    closeSubNavPopup: k,
    setNavItemsOverflowState: w
  } = kt(), f = Qe(), [L] = F(["Below LG"]), G = e === "Always" || e === "When Hero CTA leaves viewport" || e === "Sectional" && !L, Se = (e !== "Sectional" || L) && m === "Default", { activeSectionId: A, activeSectionTitle: q, stickyEdgeId: he } = Tt(i);
  (e === "Always" || e === "Sectional") && (f.unpinned = f.pinned);
  const Ne = (Oe) => E(Oe), K = e === "Always" || e === "Sectional" ? !0 : h === "pinned", Ce = (i == null ? void 0 : i.length) > 0 && (o == null ? void 0 : o.length) > 0 && m === "Default", be = e === "Sectional" && !A, j = e === "Always" || e === "Sectional", fe = j ? at : ot, { ariaLabel: Ee, popupCloseButtonLabel: ke = "" } = t;
  yt({
    isSticky: h === "pinned",
    height: f.pinned
  });
  const we = g(
    y.getElementClassName("divider-vertical"),
    {
      "sub-nav-item-hidden": b !== x
    }
  ), Te = g(a, {
    "subnav-sectional": e === "Sectional",
    [y.getElementClassName("no-border")]: u === "Hide"
  }), ye = g(y.getElementClassName("grid-item"), {
    [y.getElementClassName("grid-item-overflow")]: b === x
  }), J = e === "Sectional" ? s[A || he || ""] ?? [] : o, Ie = e === "Sectional" ? Ze : et, xe = b === x || e !== "Sectional" || !q ? n : q;
  return /* @__PURE__ */ l(
    tt,
    {
      classNameGen: y,
      analyticsCompName: c,
      generateDataPaClickFunction: Xe,
      children: /* @__PURE__ */ l(
        fe,
        {
          theme: r,
          shouldShrinkNav: K,
          updateNavRunningStatus: Ne,
          className: Te,
          children: /* @__PURE__ */ l(
            Fe,
            {
              ...Ye(
                f,
                K,
                be
              ),
              ...Ie,
              className: ye,
              children: /* @__PURE__ */ I(rt, { ariaLabel: Ee, children: [
                /* @__PURE__ */ l(
                  z,
                  {
                    as: b === x ? n.type : "Button",
                    title: xe,
                    isPopupOpen: b === "open",
                    enableRichText: e === "Sectional",
                    onClick: T,
                    displayTitle: d
                  }
                ),
                /* @__PURE__ */ l(
                  Y,
                  {
                    itemCollection: i,
                    onOverflow: w,
                    isVisible: b === x,
                    activeId: A
                  }
                ),
                /* @__PURE__ */ I(
                  Et,
                  {
                    isAnimated: e !== "Sectional" && m === "Default",
                    isPopupOpen: b === "open",
                    isStickyGrid: j,
                    children: [
                      /* @__PURE__ */ l(
                        $,
                        {
                          orientation: "vertical",
                          show: Ce,
                          className: we
                        }
                      ),
                      /* @__PURE__ */ l(
                        Z,
                        {
                          ctaCollection: J,
                          isVisible: G,
                          displayCtaGroup: m
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ I(
                  vt,
                  {
                    show: b === "open",
                    closeBtnLabel: ke,
                    onCloseButtonClick: k,
                    children: [
                      /* @__PURE__ */ l(
                        z,
                        {
                          isPopupTitle: !0,
                          title: n,
                          enableRichText: e === "Sectional"
                        }
                      ),
                      /* @__PURE__ */ l(
                        $,
                        {
                          className: y.getElementClassName(
                            "divider-horizontal"
                          )
                        }
                      ),
                      /* @__PURE__ */ l(
                        Y,
                        {
                          itemCollection: i,
                          orientation: "vertical",
                          closePopupOnItemClick: e === "Sectional",
                          closeSubNavPopup: k,
                          activeId: A
                        }
                      ),
                      /* @__PURE__ */ l(
                        Z,
                        {
                          ctaCollection: J,
                          orientation: "vertical",
                          isVisible: Se,
                          closePopupOnItemClick: e === "Sectional",
                          closeSubNavPopup: k,
                          displayCtaGroup: m
                        }
                      )
                    ]
                  }
                )
              ] })
            }
          )
        }
      )
    }
  );
};
It.displayName = V;
export {
  It as default
};
//# sourceMappingURL=SubNav.js.map
